module.exports = __webpack_public_path__ + "static/media/button_exit_selection@3x.aef4b507.png";